module.exports = __webpack_public_path__ + "img/ICAMI-LOGO.5ed06bbc.png";